import React from "react";

export default function ButtonRequire({
  title,
  functionOnClick,
  functionState,
  isDisabled,
}) {
  return (
    <button
      className="btn-lg w-full bg-[#4CA6F8] text-white disabled:bg-[#CCCCCC] disabled:text-[#7D7C7C] disabled:cursor-not-allowed"
      onClick={functionState ?? ((e) => functionOnClick(e))}
      disabled={isDisabled}
    >
      {title}
    </button>
  );
}
